export default __webpack_public_path__ + "static/media/0176.f38bfb9b.jpg";